import { PaymentMethod } from '../../interfaces';
import { PAYMENT_METHOD_ID } from '../payment-method-id';

export const ALIPAY: PaymentMethod = {
    id: PAYMENT_METHOD_ID.Alipay,
    name: 'alipay'
};
